import { WatcherFunction } from '..'
import { watchHandleErrors } from './errors'

export const errorsSagas: ReadonlyArray<WatcherFunction> = [watchHandleErrors]
